import { BaseClass } from "./base/base.service";

export class ConfigProvider extends BaseClass {
    constructor() {
        super('');
    }

    async getConfig(filter: any) {
        const res = await this.get(`configs?filter=${filter}`);
        return res.data;
    }
}
export const ConfigService = new ConfigProvider();